import type { CommunitySignUpRequest, Member, User } from "../models/community";
import api from "$utils/api";
import { processRoleLabel } from "./strings";
import { get } from "svelte/store";
import { page } from "$app/stores";

export type PaginatedEntityList<T> = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: Array<T>;
};

export type ArrayOrPaginatedType<T> = Array<T> | PaginatedEntityList<T>;

export function getArrayFromArrayOrPaginated<T>(arrayOrPaginated: ArrayOrPaginatedType<T>) {
  let entityArray: Array<T> = [];
  const paginatedEntityList = arrayOrPaginated as PaginatedEntityList<T>;

  if (paginatedEntityList.results !== undefined) {
    entityArray = paginatedEntityList.results || [];
  } else {
    entityArray = arrayOrPaginated as Array<T>;
  }
  return entityArray;
}

export function augmentCommunitySubEntityWithLink<
  T extends { uuid: string; navigateToLink?: string },
>(communitySlug: string, subEntity: T, subentityPathName: string): T {
  const usingSubdomain = get(page).data.usingSubdomain;
  const pathPrefix = usingSubdomain ? "" : `/${communitySlug}`;
  subEntity.navigateToLink = `${pathPrefix}/${subentityPathName}/${subEntity.uuid}`;
  return subEntity;
}

export function userToMember(user: User): Member {
  const roles = (user?.roles || []).map((role) => {
    const name = role.name || "";
    return {
      ...role,
      name: processRoleLabel(name),
    };
  });
  const isTeam = !!roles?.find((role) => role.isTeam);

  return {
    ...user,
    isTeam,
    roles,
    handleLower: user.handle.toLowerCase(),
  };
}

export async function joinCommunity(communitySlug: string, inviteCodeCode?: string) {
  return (
    await api.communitiesSignUpsCreate({
      communitySlug,
      communitySignUpRequest: {
        inviteCodeCode,
      } as CommunitySignUpRequest,
    })
  ).data as CommunitySignUpRequest;
}
